import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.6 4.6A2 2 0 1 1 11 8H2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12.6 19.4A2 2 0 1 0 14 16H2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Wind";
const Wind = memo(themed(Icon));
export {
  Wind
};
//# sourceMappingURL=wind.js.map
